import { Configurations, Passlog, Syslog } from "@/views";
export default [
    { path: "passlog", name: "Passlog", component: Passlog },
    { path: "configuration", name: "Configurations", component: Configurations },
    { path: "syslog", name: "Syslog", component: Syslog },
];
